"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _globals = require("../../../globals");

var _reducerActions = require("../reducer-actions");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var update = function update(dispatch, action, dispatchValue, options) {
  try {
    var _dispatch;

    if (typeof action !== 'string') {
      throw TypeError('action prop must be a string');
    }

    dispatch((_dispatch = {
      type: action
    }, _defineProperty(_dispatch, action, dispatchValue), _defineProperty(_dispatch, "reducerAction", _reducerActions.reducerActionKeys.update), _defineProperty(_dispatch, "options", {
      disableMiddleware: options !== null && options !== void 0 && options.disableMiddleware ? true : false
    }), _dispatch));
  } catch (error) {
    console.error("".concat(_globals.trebleError, " ").concat(error));
  }
};

var _default = update;
exports["default"] = _default;
module.exports = exports.default;